import React from "react";
import {Button, Checkbox, DatePicker, Input, message, Modal, Pagination, Table, Tooltip} from "antd";
import {HotSheetList, HotSheetListCopy, HotSheetPDFList, HotSheetRemove} from "../../../../models/hotsheet";
import {AddUpdateHotSheet} from "../../hotsheet/popups/AddUpdateHotSheet";
import {ShowHotSheet} from "../../hotsheet/popups/ShowHotSheet";
import {pagination, toList} from "../../../../controller/Utils";
import {HotsheetQuantityUpdate} from "./HotsheetQuantityUpdate";
import {HotsheetDateUpdate} from "./HotsheetDateUpdate";
import {Config} from "../../../../controller/Global";
import {TrackHeaderLink} from "../../TrackHeaderLink";
import {ServiceUpdate} from "../../../../models/service";

const {RangePicker} = DatePicker;
const confirm = Modal.confirm;
const Search = Input.Search;
const HOTSHEET = Config.constant.service_type.hotsheet;
const MANIFEST = Config.constant.service_type.manifest;

export class HotsheetPerformed extends React.Component {
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
    popvisible: false,
    qtyVisibleMdl: false,
    dateVisibleMdl: false,
    printChoices: {},
    qtyData: {},
    printLoading: false,
    copyBtnLoading: false
  };

  showPrintHotSheet = (row_id) => {
    this.setState({
      printVisible: true,
      row_id: row_id
    });
    // HotSheetPDFList({ids: row_id, pdf_type: HOTSHEET})
  }
  handleCancel = () => {
    this.setState({
      printVisible: false,
    });
  }
  PDFPrintOption = (counter = 0) => {
    const {row_id, printChoices} = this.state;
    const data = toList(printChoices);
    const key = Object.keys(printChoices)[counter]
    if (key === HOTSHEET) {
        HotSheetPDFList({ids: row_id, pdf_type: HOTSHEET})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}});
             else
               this.PDFPrintOption(counter, data)
          })
      }
      else if (key.startsWith(MANIFEST)) {
        HotSheetPDFList({ids: row_id, pdf_type: MANIFEST})
          .then(response => {
            counter += 1;
            if (data.length === counter)
              this.setState({printBtnLoading: false, printVisible: false, printChoices: {}})
            else
              this.PDFPrintOption(counter, data)
          })
      }
  }
  selectedChoicesPrint = (e) => {
    let {printChoices} = this.state;
    if (!e.target.checked)
      delete printChoices[e.target.name];
    else {
      printChoices[e.target.name] = e.target.value;
      this.setState({printChoices});
    }
  }
  onHotSheetRowPrintClick = () => {
    this.setState({printBtnLoading: true});
    this.PDFPrintOption()
  };

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({selectedRowKeys});
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      ...filters,
    });
  };
  fetch = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({loading: true, params});
    params['table'] = true;
    params['pagination'] = 50;
    HotSheetList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.defaultPageSize = 50;
        pagination.pageSize = 50;
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });

      });
  };
  onRowDeleteClick = (keys) => {
    const $this = this;
    confirm({
      title: 'Are you sure delete this Hot Sheet(s)?',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      centered: true,
      onOk() {
        keys.forEach(id => {
          HotSheetRemove(id)
            .then(response => {
              message.success('Hot Sheet(s) deleted successfully');
              $this.fetch();
            });
        });
      },
    });
  };

  onDateRangeChange = (date, dateString) => {
    this.fetch({
      next_date_fields: 'next_service_date',
      start_date: dateString[0],
      end_date: dateString[1],
    });
  };

  onRowShowClick = (ids) => {
    this.setShowHotSheetModel(true);
    this.setState({showHotSheetModelData: ids})
  };
  onRowUpdateClick = (moderatedHotSheet) => {
    this.setState({moderatedHotSheet});
    this.setAddUpdateHotSheetModel(true);
  };
  setEditQtyVisible = (id, qtyVisibleMdl) => {
    this.setState({qtyVisibleMdl});
    id && this.fetchQty(id);
  };
  setEditDateVisible = (id,  dateVisibleMdl) => {
    this.setState({dateVisibleMdl});
    id && this.fetchServiceDate(id);
  };

  CopyWorkOrder = () => {
    const {selectedRowKeys} = this.state;
    if(selectedRowKeys.length){
      this.setState({copyBtnLoading: true});
      HotSheetListCopy({ids: selectedRowKeys})
      .then(response => {
        this.setState({copyBtnLoading: false});
        message.success("Hotsheet copy created successfully");
      })
    }
  }

  fetchServiceDate = (id) => {
    const rows = this.state.data;
    this.setState({rowServiceDateUpdate: rows.filter(item => item.service.id === id)[0]})
  };

  fetchQty = (id) => {
    const qtyRow = this.state.data;
    this.setState({qtyRow: qtyRow.filter(item => item.id === id)[0]})
  };

  disableHotSheet = (id) => {
    ServiceUpdate(id, {'heat': true})
      .then(response => {
        this.fetch()
      })
  };

  enableHotSheet = (id) => {
    ServiceUpdate(id, {'heat': false})
      .then(response => {
        this.fetch()
      })
  };

  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View" onClick={() => this.onRowShowClick([item.id])}><i className="fa fa-eye"/></a>
        {!item.service.heat && <a title="Edit" onClick={() => this.onRowUpdateClick(item.id)}><i className="fa fa-pencil"/></a>}
        {!item.service.heat && <a title="Delete" onClick={() => this.onRowDeleteClick([item.id])}><i className="fa fa-trash"/></a>}
        {/*{!item.service.heat && <a title="Print" className={item.print?'is-print-btn':''} onClick={() => this.showPrintHotSheet(item.id)} ><i className="icon-printer" /></a>}*/}
      </div>
    },
    {
      title: 'HotSheet Number',
      dataIndex: 'hot_sheet_number',
      key: 'hot_sheet_number',
      sorter: true
    },
    {
      title: <span className="billto-column-tbl">Hotsheet Type</span>,
      dataIndex: 'service',
      key: 'service__waste_stream__waste_stream__code',
      render: service => service.waste_data.map(item => item.waste_stream.code).join(', '),
      sorter: true,
      filterMultiple: false,
      filters: [{
      text: 'WWF',
      value: 'WWF',
    },
        {
      text: 'N001',
      value: 'N001',
    }, {
      text: 'N855',
      value: 'N855',
    }],
    }, {
      title: <span className="billto-column-tbl">Generator</span>,
      dataIndex: 'generator',
      render: generator => <Tooltip placement="top" title={`${generator.address} ${generator.city} ${generator.zip_code}`}><span
        className="uppercase-letter">{generator.company_name}<br/>ID: {generator.account_number}<i
        className="fa fa-info-circle"/></span></Tooltip>,
      sorter: true,
      key: 'generator'
    }, {
      title: <span className="billto-column-tbl">User</span>,
      dataIndex: 'user',
      key: 'user',
      render: (user) => user ? `${user.first_name} ${user.last_name}` : 'N/A',
      sorter: true
    }, {
      title: <span className="billto-column-tbl">Bill To</span>,
      dataIndex: 'bill_to',
      key: 'bill_to',
      render: bill_to => <Tooltip placement="top" title={`${bill_to.address} ${bill_to.city} ${bill_to.zip_code}`}><span>{bill_to.company_name}<br /> ID: {bill_to.account_number}<i className="fa fa-info-circle" /></span></Tooltip>,
    }, {
      title: 'Town',
      dataIndex: 'generator',
      key: 'generator__city',
      render: generator => generator.city,
      sorter: true
    }, {
      title: 'Transporter',
      dataIndex: 'service',
      key: 'service__transporter',
      render: service => service.transporter.name
    },
    {
      title: 'Cycle',
      dataIndex: 'service',
      key: 'service__cycle',
      render: service => service.cycle,
    },
    {
      title: 'Service Date',
      dataIndex: 'service',
      key: 'service_date',
      render: service => <div> {service.prev_service_date}<br/>
        {service.heat? '-':<a className={"edit-quantity-btn"} onClick={() => this.setEditDateVisible(service.id, true)} href="#"><i
          className={"fa fa-pencil"}> </i> Edit</a>}
      </div>
    }, {
      title: 'Next Service Date',
      dataIndex: 'service',
      key: 'next_service_date',
      render: service => service.heat?'-': service.next_service_date,
    }, {
      title: 'Status',
      dataIndex: 'service',
      key: 'status',
      render: (service) => <span className={service.status}><i className="fa fa-circle"/></span>
    }, {
      title: 'Heat',
      dataIndex: 'service',
      key: 'service.heat',
      render: (service) => <div className="action-column job-enble">{service.heat?
        <a title="Start HotSheet" className="enable-job" onClick={() => this.enableHotSheet(service.id)}><i className="fa fa-check"/></a>:
        <a title="Stop HotSheet" className="disable-job" onClick={() => this.disableHotSheet(service.id)}><i className="fa fa-close"/></a>}
        </div>
    }
  ];

  setAddUpdateHotSheetModel(addUpdateHotSheetModel) {
    this.setState({addUpdateHotSheetModel});
  }

  setShowHotSheetModel(showHotSheetModel) {
    this.setState({showHotSheetModel});
  }

  printHotSheetRecords = () => {
    this.setState({printLoading: true});
    const {params} = this.state;
    params['pdf_type'] = 'work_performed';
    HotSheetPDFList(params)
      .then(response => {
            this.setState({printLoading: false})
      })
  }
  onMultipleRowPrintClick = () => {
    const {params, selectedRowKeys, ids} = this.state;
    HotSheetPDFList({...params, 'pdf_type': 'hotsheet_manifest', 'ids': selectedRowKeys})
  }

  componentDidMount() {
    this.fetch();
  }

  render() {
    const {pagination, data, loading, copyBtnLoading, selectedRowKeys, row_id, qtyRow, qtyVisibleMdl, dateVisibleMdl, printBtnLoading, rowServiceDateUpdate} = this.state;
    const rowSelection = {
      selectedRowKeys,
      getCheckboxProps: record => ({
        disabled: record.service.heat,
      }),
      onChange: this.onCheckboxSelectChange,

    };


    return (
      <div id="main-content">
      <div className="container-fluid">
        <div className="row clearfix">
          <div className="col-sm-3 col-12">
            <h3 className="main-heading">AB Tracks</h3>
          </div>
          <div className="col-sm-9 col-12">
            <TrackHeaderLink/>
          </div>
        </div>
        <div className="row clearfix edit-header">
          <div className="col-sm-2 col-12 text-center">
            <Button className="btn submit-btn print-performed" loading={this.state.printLoading} htmlType="button" onClick={this.printHotSheetRecords}><i className="icon-printer"> </i> Print Records</Button>
          </div>
          <div className="col-sm-3 col-12">
            <div id="date_range_wrapper">
              <RangePicker onChange={this.onDateRangeChange}/>
            </div>
          </div>
          <div className="col-sm-3 col-12">
            <Search placeholder="Input search text" onSearch={value => this.fetch({search: value})} style={{width: "100%"}}/>
          </div>
          <div className="col-sm-2 col-12 ">
            <Button loading={copyBtnLoading} className="btn submit-btn" onClick={this.CopyWorkOrder}>Copy Work Order</Button>
          </div>
           <div className="col-sm-2 col-12">
            <span>{pagination.total} Records</span>
          </div>
        </div>
        <div className="row clearfix">
          <div className="col-12">
            <div className="listing-table">
              <Table
                className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                pagination={pagination} rowSelection={rowSelection} rowKey={row => row.id} columns={this.columns}
                dataSource={data} loading={loading} onChange={this.handleTableChange}
                locale={{emptyText: 'No Hot Sheet Available'}}/>
            </div>
          </div>
        </div>
        <div className="modal">
          <AddUpdateHotSheet moderated={this.state.moderatedHotSheet} visible={this.state.addUpdateHotSheetModel}
                             setModelVisible={() => this.setAddUpdateHotSheetModel(false)} fetch={() => this.fetch()}/>
        </div>
        <ShowHotSheet visible={this.state.showHotSheetModel} setModelVisible={() => this.setShowHotSheetModel(false)}
                      data={this.state.showHotSheetModelData}/>
        {qtyVisibleMdl && <HotsheetQuantityUpdate visible={qtyVisibleMdl} row={qtyRow} setModelVisible={() => this.setEditQtyVisible(false)} fetch={() => this.fetch()}/>}
        {dateVisibleMdl && <HotsheetDateUpdate visible={dateVisibleMdl} row={rowServiceDateUpdate} setModelVisible={() => this.setEditDateVisible(false)} fetch={() => this.fetch()}/>}
        <Modal title="Select Print Option" confirmLoading={printBtnLoading} visible={this.state.printVisible} onOk={this.onHotSheetRowPrintClick} onCancel={this.handleCancel} okText="Download PDF" className="print-modal" width={300} destroyOnClose={true}>
          <div>
            <div className="check-div">
              <Checkbox name={HOTSHEET} value={row_id} onChange={this.selectedChoicesPrint}>Print Hot Sheet</Checkbox>
            </div>
            {data.map(row => {
              return (row.id === row_id &&
                <div key={row.id} className="check-div uppercase-letter">
                    <Checkbox value={row.service.manifest_number} name={MANIFEST} onChange={this.selectedChoicesPrint}>Print {MANIFEST === row.service.type? 'Manifest': 'BOL'}: {row.service.manifest_number}</Checkbox>
                </div>)
            })}
          </div>
        </Modal>
      </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/tracks/work_perform/hotsheet_performed/HotsheetPerformed.jsx